export const claimsInitialState = [
  {
    id: 'CLM-2024-001',
    claimNumber: 'BIM-CLM-001',
    policyNumber: 'BIM-2024-001',
    clientName: 'Acme Corporation',
    claimType: 'Property Damage',
    status: 'under-review',
    claimAmount: 15000000,
    approvedAmount: null,
    dateFiled: '2024-10-15',
    incidentDate: '2024-10-10',
    assessor: 'John Doe',
    priority: 'high',
    documents: 8,
    daysOpen: 27,
  },
  {
    id: 'CLM-2024-002',
    claimNumber: 'BIM-CLM-002',
    policyNumber: 'BIM-2024-002',
    clientName: 'Tech Solutions Ltd',
    claimType: 'Professional Liability',
    status: 'approved',
    claimAmount: 8500000,
    approvedAmount: 7500000,
    dateFiled: '2024-09-20',
    incidentDate: '2024-09-15',
    assessor: 'Sarah Smith',
    priority: 'medium',
    documents: 12,
    daysOpen: 52,
  },
  {
    id: 'CLM-2024-003',
    claimNumber: 'BIM-CLM-003',
    policyNumber: 'BIM-2024-007',
    clientName: 'Transport Logistics',
    claimType: 'Vehicle Accident',
    status: 'submitted',
    claimAmount: 4200000,
    approvedAmount: null,
    dateFiled: '2024-11-05',
    incidentDate: '2024-11-01',
    assessor: 'Michael Brown',
    priority: 'urgent',
    documents: 5,
    daysOpen: 6,
  },
  {
    id: 'CLM-2024-004',
    claimNumber: 'BIM-CLM-004',
    policyNumber: 'BIM-2024-004',
    clientName: 'Healthcare Plus',
    claimType: 'Medical Malpractice',
    status: 'investigating',
    claimAmount: 25000000,
    approvedAmount: null,
    dateFiled: '2024-10-01',
    incidentDate: '2024-09-25',
    assessor: 'John Doe',
    priority: 'high',
    documents: 15,
    daysOpen: 41,
  },
  {
    id: 'CLM-2024-005',
    claimNumber: 'BIM-CLM-005',
    policyNumber: 'BIM-2024-003',
    clientName: 'Global Traders Inc',
    claimType: 'Cargo Loss',
    status: 'paid',
    claimAmount: 18000000,
    approvedAmount: 16500000,
    dateFiled: '2024-08-15',
    incidentDate: '2024-08-10',
    assessor: 'Sarah Smith',
    priority: 'medium',
    documents: 10,
    daysOpen: 88,
  },
  {
    id: 'CLM-2024-006',
    claimNumber: 'BIM-CLM-006',
    policyNumber: 'BIM-2024-001',
    clientName: 'Acme Corporation',
    claimType: 'Fire Damage',
    status: 'rejected',
    claimAmount: 32000000,
    approvedAmount: 0,
    dateFiled: '2024-09-10',
    incidentDate: '2024-09-05',
    assessor: 'Michael Brown',
    priority: 'high',
    documents: 9,
    daysOpen: 62,
  },
  {
    id: 'CLM-2024-007',
    claimNumber: 'BIM-CLM-007',
    policyNumber: 'BIM-2024-006',
    clientName: 'Retail Masters',
    claimType: 'Theft',
    status: 'under-review',
    claimAmount: 5800000,
    approvedAmount: null,
    dateFiled: '2024-10-25',
    incidentDate: '2024-10-20',
    assessor: 'John Doe',
    priority: 'medium',
    documents: 6,
    daysOpen: 17,
  },
  {
    id: 'CLM-2024-008',
    claimNumber: 'BIM-CLM-008',
    policyNumber: 'BIM-2024-008',
    clientName: 'Manufacturing Industries',
    claimType: 'Product Liability',
    status: 'approved',
    claimAmount: 12000000,
    approvedAmount: 11000000,
    dateFiled: '2024-09-05',
    incidentDate: '2024-08-28',
    assessor: 'Sarah Smith',
    priority: 'high',
    documents: 14,
    daysOpen: 67,
  },
  {
    id: 'CLM-2024-009',
    claimNumber: 'BIM-CLM-009',
    policyNumber: 'BIM-2024-007',
    clientName: 'Transport Logistics',
    claimType: 'Vehicle Theft',
    status: 'investigating',
    claimAmount: 9500000,
    approvedAmount: null,
    dateFiled: '2024-10-30',
    incidentDate: '2024-10-28',
    assessor: 'Michael Brown',
    priority: 'urgent',
    documents: 7,
    daysOpen: 12,
  },
  {
    id: 'CLM-2024-010',
    claimNumber: 'BIM-CLM-010',
    policyNumber: 'BIM-2024-002',
    clientName: 'Tech Solutions Ltd',
    claimType: 'Data Breach',
    status: 'submitted',
    claimAmount: 22000000,
    approvedAmount: null,
    dateFiled: '2024-11-08',
    incidentDate: '2024-11-05',
    assessor: 'John Doe',
    priority: 'urgent',
    documents: 4,
    daysOpen: 3,
  },
];
